export enum HorizontalAlignment {
  LEFT = "START",
  CENTER = "CENTER",
  RIGHT = "END",
}
